export const SHOW_PARAMS = [ "revenue", "spend", "roi", "cutoff" ];


// WEBPACK FOOTER //
// ./src/scenes/DummyCutoff/config.js